export default __webpack_public_path__ + "static/media/verify-email.ae1cfd7c.svg";